import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import Header from "../../common_components/Header";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Footer from "../../common_components/Footer";
import { v4 as uuidv4 } from "uuid";
import { getCmsContent_action, insertUpdateCmsMenu_action, deleteCmsMenu_action } from "../../actions/cms_action/cmsAction";
import { toastError, toastSuccess } from "../../utils/constants";
import { ToastContainer } from "react-toastify";

class cmsHeaderMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuList: [],
            isLoading: false,
            cmsMenuData: [],
            cmsFooterData: [],
        };
    }

    componentDidMount() {
        if (!JSON.parse(sessionStorage.getItem("loginDataSS"))) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
            return;
        }
        if (sessionStorage.getItem('RoleIDSS') != 1) {
            setTimeout(() => {
                this.props.navigate('/memberDashboard');
            }, 200);
            return;
        }
        window.scrollTo(0, 0);
        this.setState({ MenuID: 1, MenuUrl: 'home', cmsMenuData: [] }, () => {
            this.getCmsContent();
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            const urlHash = this.props.location.pathname;
            const cmsPrefix = '/cms/manage/';
            console.log(this.props.location, 'did');

            if (urlHash.includes('RegisteredList')) {
                window.open('#/RegisteredList', '_blank');
            } else if (urlHash.includes('companyProfile')) {
                window.open('#/companyProfile', '_blank');
            } else if (urlHash.includes('buisnessDetails')) {
                window.open('#/buisnessDetails', '_blank');
            } else if (urlHash.includes('payment')) {
                window.open('#/payment', '_blank');
            } else if (urlHash.includes('thankyou')) {
                window.open('#/thankyou', '_blank');
            } else if (urlHash.includes('enquiryForm')) {
                window.open('#/enquiryForm', '_blank');
            } else if (urlHash.includes('eventEnquiryForm')) {
                window.open('#/eventEnquiryForm', '_blank');
            } else {
                if (urlHash.startsWith(cmsPrefix)) {
                    const subPath = urlHash.substring(cmsPrefix.length);

                    const parts = subPath.split('&');
                    if (parts.length === 2) {
                        const menuURL = parts[0];
                        const MenuID = parts[1];

                        console.log("Menu URL:", menuURL);
                        console.log("Menu ID:", MenuID);

                        if (MenuID === '1') {
                            window.location.reload();
                            return;
                        }

                        this.setState({ menuURL, MenuID, cmsMenuData: [] }, () => {
                            this.getCmsContent(MenuID);
                        });
                    }
                }
            }

            console.log("URL changed to:", this.props.location.pathname);
        }
    }

    async getCmsContent() {
        try {
            this.setState({ isLoading: true });

            const data = await this.props.getCmsContent_action(1, 'home');

            if (data.error !== 1) {
                const flatList = data?.data?.[1] || [];

                const menuMap = {};
                flatList.forEach(item => {
                    item.id = uuidv4();
                    item.children = [];
                    item.showSave = false;
                    menuMap[item.MenuID] = item;
                });

                const rootMenus = [];
                flatList.forEach(item => {
                    if (item.ParentID) {
                        if (menuMap[item.ParentID]) {
                            menuMap[item.ParentID].children.push(item);
                        }
                    } else {
                        rootMenus.push(item);
                    }
                });

                this.setState({
                    isLoading: false,
                    cmsMenuData: data?.data?.[1],
                    cmsFooterData: data?.data?.[2][0],
                    menuList: rootMenus,
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    handleInputChange = (id, field, value) => {
        if (field === 'Url') value = value.replace(/\s/g, '');

        const updateTree = (menus) => menus.map(menu => {
            if (menu.id === id) {
                return { ...menu, [field]: value, showSave: true };
            }
            if (menu.children && menu.children.length > 0) {
                return { ...menu, children: updateTree(menu.children) };
            }
            return menu;
        });

        this.setState(prev => ({ menuList: updateTree(prev.menuList) }));
    };

    addNewMenu = (parentId = null) => {
        const createNewMenu = (sequence) => ({
            id: uuidv4(),
            MenuID: null,
            ParentID: parentId,
            Title: "",
            Url: "",
            Sequence: sequence,
            isActive: true,
            isPublish: true,
            isMenuItem: true, // Default to true based on component 2 structure
            children: [],
            showSave: true
        });

        if (!parentId) {
            const maxSequence = this.state.menuList.reduce((max, item) => Math.max(max, item.Sequence || 0), 0);
            this.setState(prev => ({
                menuList: [...prev.menuList, createNewMenu(maxSequence + 1)],
            }));
            return;
        }

        const updateTree = (menus) => menus.map(menu => {
            if (menu.id === parentId) {
                const children = menu.children || [];
                const maxChildSequence = children.reduce((max, item) => Math.max(max, item.Sequence || 0), 0);
                return { ...menu, children: [...children, createNewMenu(maxChildSequence + 1)] };
            }
            if (menu.children && menu.children.length > 0) {
                return { ...menu, children: updateTree(menu.children) };
            }
            return menu;
        });

        this.setState(prev => ({ menuList: updateTree(prev.menuList) }));
    };

    async deleteCmsMenu(menu) {
        if (menu.MenuID) {
            try {
                this.setState({ isLoading: true });
                const isConfirm = window.confirm('Are you sure you want to remove this Menu?');
                if (isConfirm) {
                    const data = await this.props.deleteCmsMenu_action(menu.MenuID);
                    if (data.error !== 1 && data.data !== "") {
                        toastSuccess(`Menu Deleted Successfully`);
                        this.getCmsContent();
                    } else {
                        toastError(data.msg);
                    }
                }
            } catch (err) {
                console.error(err);
            } finally {
                this.setState({ isLoading: false });
            }
        } else {
            const removeNode = (menus) => menus
                .filter(item => item.id !== menu.id)
                .map(item => {
                    if (item.children && item.children.length > 0) {
                        return { ...item, children: removeNode(item.children) };
                    }
                    return item;
                });

            this.setState(prev => ({ menuList: removeNode(prev.menuList) }));
        }
    }

    onDragEnd = result => {
        const { source, destination, type } = result;
        if (!destination) return;

        if (type === "PARENT") {
            const items = Array.from(this.state.menuList);
            const [reorderedItem] = items.splice(source.index, 1);
            items.splice(destination.index, 0, reorderedItem);
            this.setState({ menuList: items });
            return;
        }

        const updateTreeForDnd = (menus) => menus.map(item => {
            if (item.id.toString() === type) {
                const children = Array.from(item.children || []);
                const [reorderedChild] = children.splice(source.index, 1);
                children.splice(destination.index, 0, reorderedChild);
                return { ...item, children };
            }
            if (item.children && item.children.length > 0) {
                return { ...item, children: updateTreeForDnd(item.children) };
            }
            return item;
        });

        this.setState(prev => ({ menuList: updateTreeForDnd(prev.menuList) }));
    };

    renderMenuRow = (menu, index, sequencePrefix = "", depth = 0) => {
        const currentSequenceStr = `${sequencePrefix}${menu.Sequence}`;
        const bgColor = depth === 0 ? "white" : depth === 1 ? "#eee" : "#f5f5f5";

        return (
            <Draggable key={menu.id} draggableId={menu.id.toString()} index={index}>
                {(provided) => (
                    <tr
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{ ...provided.draggableProps.style, backgroundColor: bgColor }}
                    >
                        <td style={{ width: '425px' }}>
                            <input style={{ width: '100%' }} type="text" placeholder="Title" className="form-control"
                                value={menu.Title} onChange={(e) => this.handleInputChange(menu.id, "Title", e.target.value)} />
                        </td>
                        <td style={{ width: '430px' }}>
                            <input type="text" placeholder="Url" className="form-control"
                                value={menu.Url} onChange={(e) => this.handleInputChange(menu.id, "Url", e.target.value)} />
                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            {currentSequenceStr}
                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            <div className="custom-control custom-checkbox d-flex justify-content-center pt-2">
                                <input type="checkbox"
                                    className="custom-control-input"
                                    id={`customCheck${menu.id}`}
                                    checked={menu.isActive}
                                    value={menu.isActive}
                                    onChange={() => this.handleInputChange(menu.id, "isActive", !menu.isActive)}
                                />
                                <label className="custom-control-label" htmlFor={`customCheck${menu.id}`}></label>
                            </div>
                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            <div className="custom-control custom-checkbox d-flex justify-content-center pt-2">
                                <input type="checkbox"
                                    className="custom-control-input"
                                    id={`publishCheckbox${menu.id}`}
                                    checked={menu.isPublish}
                                    value={menu.isPublish}
                                    onChange={() => this.handleInputChange(menu.id, "isPublish", !menu.isPublish)}
                                />
                                <label className="custom-control-label" htmlFor={`publishCheckbox${menu.id}`}></label>
                            </div>
                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            <div className="custom-control custom-checkbox d-flex justify-content-center pt-2">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id={`menuItemCheckbox${menu.id}`}
                                    checked={menu.isMenuItem}
                                    value={menu.isMenuItem}
                                    onChange={() => this.handleInputChange(menu.id, "isMenuItem", !menu.isMenuItem)}
                                />
                                <label className="custom-control-label" htmlFor={`menuItemCheckbox${menu.id}`}></label>
                            </div>
                        </td>
                        <td className="text-right" style={{ width: '100px' }}>
                            {/* LOGIC CHANGE: Only show the '+' button if the menu has a MenuID from the database */}
                            {menu.MenuID ? (
                                <button className="btn btn-sm btn-outline-success mx-2" title="Add Submenu" onClick={() => this.addNewMenu(menu.id)}>+</button>
                            ) : null}
                            <button className="btn btn-sm btn-outline-danger" title="Delete Menu" onClick={() => this.deleteCmsMenu(menu)}><i className="fa fa-trash-o"></i></button>
                        </td>
                    </tr>
                )}
            </Draggable>
        );
    };
    renderDroppableChildren = (menu, sequencePrefix, depth) => {
        if (!menu.children || menu.children.length === 0) return null;

        return (
            <Droppable droppableId={menu.id.toString()} type={menu.id.toString()}>
                {(providedChild) => (
                    <tr>
                        <td className="pr-0" colSpan="7" style={{ paddingLeft: '20px', borderLeft: '3px solid #ccc', background: depth === 0 ? '#eee' : '#f5f5f5' }}>
                            <table className="table mb-0">
                                <tbody ref={providedChild.innerRef} {...providedChild.droppableProps}>
                                    {menu.children.sort((a, b) => a.Sequence - b.Sequence).map((child, childIndex) => (
                                        <React.Fragment key={child.id}>
                                            {this.renderMenuRow(child, childIndex, sequencePrefix, depth + 1)}
                                            {this.renderDroppableChildren(child, `${sequencePrefix}${child.Sequence}.`, depth + 1)}
                                        </React.Fragment>
                                    ))}
                                    {providedChild.placeholder}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                )}
            </Droppable>
        );
    };

    async submitMenu() {
        try {
            const { menuList } = this.state;
            this.setState({ isLoading: true });

            const flatMenuList = [];

            const flattenMenus = (menus, parentId = null) => {
                for (const item of menus) {
                    const { children, id, showSave, ...itemData } = item;

                    const hasInvalidItem = !itemData.Title?.trim();
                    // || !itemData.Url?.trim();
                    if (hasInvalidItem) {
                        throw new Error('Kindly Enter Title in all Menu items.');
                    }

                    flatMenuList.push({
                        MenuID: itemData.MenuID || null,
                        ParentID: parentId,
                        Title: itemData.Title,
                        Url: itemData.Url,
                        Sequence: itemData.Sequence,
                        isActive: itemData.isActive,
                        isPublish: itemData.isPublish,
                        isMenuItem: itemData.isMenuItem
                    });

                    if (children && children.length > 0) {
                        if (itemData.MenuID) {
                            // If it's an existing parent, associate kids with MenuID
                            flattenMenus(children, itemData.MenuID);
                        } else {
                            // If parent is completely new, you'll need API support to handle nested inserts 
                            // properly, or handle them sequentially inside the submit block. This assumes 
                            // backend recursive capabilities based on order, or just passes null.
                            flattenMenus(children, null);
                        }
                    }
                }
            };

            try {
                flattenMenus(menuList, null);
            } catch (validationError) {
                toastError(validationError.message);
                this.setState({ isLoading: false });
                return;
            }

            const data = await this.props.insertUpdateCmsMenu_action(flatMenuList);
            this.setState({ isLoading: false });

            if (data.error !== 1) {
                toastSuccess('Menu Added Successfully');
                this.getCmsContent();
            } else {
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    render() {
        const { menuList, cmsMenuData, cmsFooterData } = this.state;

        return (<>
            <ToastContainer />
            <Header headerNavs={cmsMenuData} />
            <section className="registration_form">
                <div className="container">
                    <div className="row ">
                        <section className="table_section mt-0">
                            <div className="container">
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-lg-12">
                                        <div className="card shadow-none border mb-2" >
                                            <div className="card-header py-2">
                                                <h6 className='pt-2' style={{ float: 'left' }}>CMS Menu Settings</h6>
                                                <a style={{ float: 'right' }}
                                                    href="javascript:void(0);"
                                                    title="Add Menu"
                                                    onClick={() => this.addNewMenu()}
                                                    className="load_document_icon p-1 px-2 nav-add-btn mx-1"
                                                >
                                                    Add Menu
                                                </a>
                                            </div>
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '425px' }}>Title</th>
                                                        <th style={{ width: '425px' }}>URL</th>
                                                        <th className="text-center" style={{ width: '100px' }}>Sequence</th>
                                                        <th className="text-center" style={{ width: '100px' }}>Active</th>
                                                        <th className="text-center" style={{ width: '100px' }}>Publish</th>
                                                        <th className="text-center" style={{ width: '100px' }}>Menu Item</th>
                                                        <th className="text-right" style={{ width: '100px' }}>Actions</th>
                                                    </tr>
                                                </thead>
                                                <DragDropContext onDragEnd={this.onDragEnd}>
                                                    <Droppable droppableId="menuList" type="PARENT">
                                                        {(provided) => (
                                                            <tbody ref={provided.innerRef} {...provided.droppableProps}>
                                                                {menuList.length > 0 ? (
                                                                    menuList.sort((a, b) => a.Sequence - b.Sequence).map((menu, index) => (
                                                                        <React.Fragment key={menu.id}>
                                                                            {this.renderMenuRow(menu, index, "", 0)}
                                                                            {this.renderDroppableChildren(menu, `${menu.Sequence}.`, 0)}
                                                                        </React.Fragment>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={7} className="text-center">No Record Found</td>
                                                                    </tr>
                                                                )}
                                                                {provided.placeholder}
                                                            </tbody>
                                                        )}
                                                    </Droppable>
                                                </DragDropContext>
                                            </table>
                                            <div className="m-2">
                                                {menuList.length > 0 && <>
                                                    <button className="load_document_icon p-1 px-2 edit-submit-btn rounded-1" style={{ padding: '5px 15px !important' }}
                                                        onClick={() => this.submitMenu()}>Submit Menu</button>
                                                </>}
                                                <button className="load_document_icon p-1 px-2 add-sec-btn mx-2 rounded-1" style={{ padding: '5px 15px !important' }}
                                                    onClick={() => this.addNewMenu()}>Add Menu</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </section>
            <Footer footerData={cmsFooterData} />
        </>
        );
    }
}

export default withRouter(connect(null, { getCmsContent_action, insertUpdateCmsMenu_action, deleteCmsMenu_action })(cmsHeaderMaster));